import React from 'react'
import './index.css';
import Property1 from '../../../component/Explore/Propertypage'

const Property = () => {
  return (
    <div>
      <Property1 type="Single Rustic Room" desc="Come and enjoy the experience of a single rustic cabin with your partner. Enjoy the vibe of a vibrant weather and a cosy location." roomdesc = "Pre-Book Your room for your partner , family or friends to enjoy the seamless checkin." price = "1300" guests="2" bed="1"  bath="1" num="+91-2934572"/>
    </div>
  )
}

export default Property
